<template>
  <v-container class="ma-0 pa-0">
    <v-card class="rounded-lg pa-4">
      <v-card-title class="d-flex justify-center">
        <h3 class="title font-weight-medium" style="color: #344054;">
          Transacciones fallidas
        </h3>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        <v-form ref="form" :valid="search.valid" lazy-validation>
          <v-row no-gutters justify="center">
            <v-col
              cols="12"
              class="d-flex justify-center align-center flex-column"
            >
              <span class="body-1 text-center" style="color: #344054;">
                Buscar transacción fallida por:
              </span>
              <v-radio-group v-model="search.searchBy" row>
                <v-radio
                  v-for="(item, i) in search.searchOptions"
                  :key="i"
                  :value="item.value"
                  color="#2661FF"
                >
                  <template v-slot:label>
                    <div>
                      <span
                        class="subtitle-2"
                        style="color: #344054; text-transform: uppercase;"
                        >{{ item.text }}</span
                      >
                    </div>
                  </template>
                </v-radio>
              </v-radio-group>
            </v-col>
            <v-col cols="12" md="6" v-show="search.searchBy">
              <v-text-field
                v-model="search.searchParam"
                :label="`Buscar por`"
                :placeholder="`${search.searchBy.toUpperCase()}`"
                dense
                outlined
                class="rounded-lg"
                :rules="search.rules.searchParam"
              ></v-text-field>
            </v-col>
            <v-col cols="12" class="d-flex justify-center">
              <v-btn
                class="rounded-lg"
                color="#2661FF"
                @click="searchTransaction"
              >
                <v-icon color="white">search</v-icon>
                <span class="ml-1" style="color: white;">Buscar</span>
              </v-btn>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
      <v-card-text>
        <div
          v-if="search.isLoading"
          class="d-flex justify-center align-center my-10"
          style="height: 100%;"
        >
          <v-progress-circular
            :size="60"
            indeterminate
            color="#2661FF"
          ></v-progress-circular>
        </div>
        <v-card
          v-else-if="subscriptionExists"
          class="rounded-lg custom_panel"
          flat
        >
          <v-card-title>
            <h3 class="title font-weight-medium" style="color: #344054;">
              ID: {{ subscription.id }}
            </h3>
            <v-spacer></v-spacer>
            <v-btn
              class="rounded-lg"
              outlined
              color="#2661FF"
              :disabled="validateTransactionStatus"
              @click="changeStatus"
            >
              <v-icon>
                refresh
              </v-icon>
              Cambiar estado
            </v-btn>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <v-row no-gutters>
              <v-col cols="12" md="6">
                <!------------------------------------------------------>
                <!-- DONATION ---------------------------------------->
                <!------------------------------------------------------>
                <v-card class="rounded-lg ma-4 custom_panel" flat>
                  <v-card-title>
                    <h3
                      class="title font-weight-medium"
                      style="color: #344054;"
                    >
                      Donación
                    </h3>
                  </v-card-title>
                  <v-card-text>
                    <InfoRow
                      label="Estado"
                      :value="getStateByNumber(subscription.state)"
                    />
                    <InfoRow
                      label="Código de transacción"
                      :value="
                        validateValue(subscription.transaction_gateway_code)
                      "
                    />
                    <InfoRow
                      label="Fecha de creación"
                      :value="subscription.created_at | moment('LLL')"
                    />
                  </v-card-text>
                </v-card>
                <!------------------------------------------------------>
                <!-- ORGANIZATION ---------------------------------------->
                <!------------------------------------------------------>
                <v-card class="rounded-lg ma-4 custom_panel" flat>
                  <v-card-title>
                    <h3
                      class="title font-weight-medium"
                      style="color: #344054;"
                    >
                      Organización
                    </h3>
                  </v-card-title>
                  <v-card-text>
                    <InfoRow
                      label="Organización"
                      :value="validateValue(subscription.organization.name)"
                    />
                    <InfoRow
                      :label="$t('people.email')"
                      :value="validateValue(subscription.organization.contact_info)"
                    />
                  </v-card-text>
                </v-card>
              </v-col>
              <v-col cols="12" md="6">
                <!------------------------------------------------------>
                <!-- LEAD ---------------------------------------->
                <!------------------------------------------------------>
                <v-card class="rounded-lg ma-4 custom_panel" flat>
                  <v-card-title>
                    <h3
                      class="title font-weight-medium"
                      style="color: #344054;"
                    >
                      Lead
                    </h3>
                  </v-card-title>
                  <v-card-text>
                    <InfoRow label="Lead" :value="subscription.lead.email" />
                    <InfoRow
                      label="Nombre"
                      :value="validateValue(subscription.lead.first_name)"
                    />
                    <InfoRow
                      label="Apellido"
                      :value="validateValue(subscription.lead.last_name)"
                    />
                  </v-card-text>
                </v-card>
                <!------------------------------------------------------>
                <!-- GATEWAY ---------------------------------------->
                <!------------------------------------------------------>
                <v-card class="rounded-lg ma-4 custom_panel" flat>
                  <v-card-title>
                    <h3
                      class="title font-weight-medium"
                      style="color: #344054;"
                    >
                      {{ $t("transactions.dashboard.gateway") }}
                    </h3>
                  </v-card-title>
                  <v-card-text>
                    <InfoRow
                      :label="$t('transactions.dashboard.gateway')"
                      :value="
                        formatGatewayName(subscription.gateway.gateway.name)
                      "
                    />
                    <InfoRow
                      :label="$t('transactions.dashboard.payment_method')"
                      :value="getPaymentMethodById(subscription.payment_method).text"
                    />
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";
import InfoRow from "@/components/Common/InfoRow";
import donationMixin from "@/mixins/donations";

export default {
  name: "failed-transactions",
  components: {
    InfoRow
  },
  mixins: [donationMixin],
  data() {
    return {
      search: {
        valid: true,
        isLoading: false,
        searchBy: "id",
        searchOptions: [
          {
            text: "Donation ID",
            value: "id"
          },
          {
            text: "Transaction gateway ID",
            value: "transaction_gateway_code"
          }
        ],
        searchParam: null,
        rules: {
          searchParam: [v => !!v || "This field is required"]
        }
      },
      isFixLoading: false
    };
  },
  watch: {
    updateRequired: {
      deep: true,
      async handler(newVal) {
        if (newVal) {
          const { search } = this;
          const payload = {
            searchBy: search.searchBy,
            searchParam: search.searchParam
          };

          await this.getTransactionByIdentifier(payload);
        }
      }
    }
  },
  computed: {
    ...mapState({
      subscription: ({ transactions: { transaction } }) => transaction,
      updateRequired: ({ transactions: { updateRequired } }) => updateRequired
    }),
    subscriptionExists() {
      const { subscription } = this;
      return Object.keys(subscription).length > 0;
    },
    validateTransactionStatus() {
      const { subscription } = this;

      const FAILED = this.getStateValueByName("failed");

      return subscription.state !== FAILED;
    }
  },
  methods: {
    ...mapActions({
      getTransactionByIdentifier: "transactions/getTransactionByIdentifier",
      fixFailedTransaction: "transactions/fixFailedTransaction"
    }),
    ...mapMutations({
      setUpdateRequired: "subscriptions/setUpdateRequired"
    }),
    async searchTransaction() {
      const { search } = this;
      const valid = await this.$refs.form.validate();
      if (valid) {
        try {
          this.search.isLoading = true;

          const payload = {
            searchBy: search.searchBy,
            searchParam: search.searchParam
          };

          await this.getTransactionByIdentifier(payload);
        } catch (error) {
          const { response } = error;
          if (response.status === 404) {
            this.$noty.error("Transacción no encontrada");
          } else {
            this.$noty.error("Error al obtener la transacción");
          }
        } finally {
          this.search.isLoading = false;
        }
      } else {
        this.$noty.error("Verifique los datos ingresados");
      }
    },
    validateValue(value) {
      return value ? value : "-";
    },
    formatGatewayName(gateway) {
      const PAYMENTS_WAY = "Bakery";

      switch (gateway) {
        case PAYMENTS_WAY:
          return "Payments Way";
        default:
          return gateway;
      }
    },
    async changeStatus() {
      const { subscription } = this;
      try {
        this.isFixLoading = true;
        await this.fixFailedTransaction({ id: subscription.id });
      } catch (error) {
        console.log(error);
        this.$noty.error("Error al obtener la transacción");
      } finally {
        this.isFixLoading = true;
        this.setUpdateRequired(false);
      }
    }
  }
};
</script>

<style>
.text_color {
  color: #344054 !important;
}

.custom_panel {
  border: 1px solid #d0d3db !important;
}
</style>
